<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/bill/banner.png" @click="$login">
    <text-left
      :text-left="{
        height: 420,
        title: '应交增值税查询',
        desc: '通过筝鸣，您可以随时查看到您的应交增值税额，从而实现更好地现金流管理。',
        textWidth: 550,
        imgWidth: 510,
        left: false,
        img: require('@/assets/bill/img2.png')
      }"/>
    <text-left
      :text-left="{
        height: 490,
        title: '增值税进项发票管理',
        desc: '筝鸣帮您精确跟踪每笔增值税进项发票，清楚掌握当月可抵扣进项税额，避免因进项发票丢失和未收到造成多缴税。',
        textWidth: 600,
        imgWidth: 430,
        left: true,
        img: require('@/assets/bill/img1.png')
      }"/>
    <text-left
      :text-left="{
        height: 550,
        title: '增值税销项发票管理',
        desc: '客户开票信息可提前维护进系统。开票时，信息查找更加快捷方便。同时，应缴增值税信息精准掌控，业务动态及时了解。',
        textWidth: 680,
        imgWidth: 400,
        left: false,
        img: require('@/assets/bill/img3.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'
export default {
  name: 'Bill',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/caigou.png'),
          title: '采购账单管控',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/purchase'
        },
        {
          img: require('@/assets/common/xiaoshou.png'),
          title: '销售账单管控',
          desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
          path: '/sale'
        },
        {
          img: require('@/assets/common/guanli.png'),
          title: '管理仪表盘',
          desc: '通过仪表盘监控企业资金流、应收、应付、费用状况',
          path: '/dashboard'
        },
        {
          img: require('@/assets/common/feiyong.png'),
          title: '费用报销管理',
          desc: '员工随时随地登录系统，完成费用报销申请与审批',
          path: '/reimbursement'
        },
        {
          img: require('@/assets/common/guding.png'),
          title: '固定资产',
          desc: '集中管理，轻松维护您的固定资产',
          path: '/estate'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
